

export enum GableSide {
    Left,
    Right
}
